import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { indexOf29nspdgx2e3ap as indexOf } from '../../../../../kotlinx-io-kotlinx-io-core/kotlinx/io/Sources.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { Buffergs925ekssbch as Buffer } from '../../../../../kotlinx-io-kotlinx-io-core/kotlinx/io/Buffer.mjs';
import {
  add2suhfggl4zvkk as add,
  fromInt2ii0rejb1w62w as fromInt,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { flushIfNeededij7q93lpr53w as flushIfNeeded } from './ByteWriteChannel.mjs';
import { writeBytequnf40dx25fy as writeByte } from './ByteWriteChannelOperations.mjs';
import { get_ONEazvfdh9ju3d4 as get_ONE } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/boxedLong/boxedLong.mjs';
import { IOException1wyutdmfe71nu as IOException } from '../../../../../kotlinx-io-kotlinx-io-core/kotlinx/io/-PlatformJs.mjs';
import { decodeToString2ede220pr5xir as decodeToString } from '../../../../../kotlinx-io-kotlinx-io-bytestring/kotlinx/io/bytestring/ByteString.mjs';
import { replace3le3ie7l9k8aq as replace } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/stringsCode.mjs';
import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { toString1pkumu07cwy4m as toString } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function buildPartialMatchTable($this) {
  var table = new Int32Array($this.matchString_1.get_size_woubt6_k$());
  var j = 0;
  var inductionVariable = 1;
  var last = $this.matchString_1.get_size_woubt6_k$();
  if (inductionVariable < last)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      while (j > 0 && !($this.matchString_1.get_c1px32_k$(i) === $this.matchString_1.get_c1px32_k$(j))) {
        j = table[j - 1 | 0];
      }
      if ($this.matchString_1.get_c1px32_k$(i) === $this.matchString_1.get_c1px32_k$(j)) {
        j = j + 1 | 0;
      }
      table[i] = j;
    }
     while (inductionVariable < last);
  return table;
}
function *advanceToNextPotentialMatch($this, $completion) {
  while (!$this.input_1.exhausted_p1jt55_k$() || (yield* $this.channel_1.awaitContent$default_rxihsg_k$(VOID, $completion))) {
    var nextMatch = indexOf($this.input_1, $this.matchString_1.get_c1px32_k$(0));
    if (nextMatch === -1n) {
      var tmp = $this.input_1;
      checkBounds($this, (tmp instanceof Buffer() ? tmp : THROW_CCE()).get_size_woubt6_k$());
      $this.bytesRead_1 = add($this.bytesRead_1, $this.input_1.transferTo_lu4ka2_k$($this.writeChannel_1.get_writeBuffer_t7kuc6_k$()));
      yield* flushIfNeeded($this.writeChannel_1, $completion);
    } else {
      checkBounds($this, nextMatch);
      var tmp_0 = $this;
      var tmp_1 = $this.bytesRead_1;
      var tmp_2 = $this.writeChannel_1.get_writeBuffer_t7kuc6_k$();
      tmp_0.bytesRead_1 = add(tmp_1, $this.input_1.readAtMostTo_4oop6l_k$(tmp_2 instanceof Buffer() ? tmp_2 : THROW_CCE(), nextMatch));
      yield* flushIfNeeded($this.writeChannel_1, $completion);
      return Unit_instance;
    }
  }
  return Unit_instance;
}
function *checkFullMatch($this, $completion) {
  while (!$this.input_1.exhausted_p1jt55_k$() || (yield* $this.channel_1.awaitContent$default_rxihsg_k$(VOID, $completion))) {
    var byte = $this.input_1.readByte_ectjk2_k$();
    if ($this.matchIndex_1 > 0 && !(byte === $this.matchString_1.get_c1px32_k$($this.matchIndex_1))) {
      var oldMatchIndex = $this.matchIndex_1;
      while ($this.matchIndex_1 > 0 && !(byte === $this.matchString_1.get_c1px32_k$($this.matchIndex_1))) {
        $this.matchIndex_1 = $this.partialMatchTable_1[$this.matchIndex_1 - 1 | 0];
      }
      var retained = fromInt(oldMatchIndex - $this.matchIndex_1 | 0);
      checkBounds($this, retained);
      var tmp = $this;
      var tmp_0 = $this.bytesRead_1;
      var tmp_1 = $this.writeChannel_1.get_writeBuffer_t7kuc6_k$();
      tmp.bytesRead_1 = add(tmp_0, $this.partialMatchBuffer_1.readAtMostTo_4oop6l_k$(tmp_1 instanceof Buffer() ? tmp_1 : THROW_CCE(), retained));
      if ($this.matchIndex_1 === 0 && !(byte === $this.matchString_1.get_c1px32_k$($this.matchIndex_1))) {
        yield* writeByte($this.writeChannel_1, byte, $completion);
        var _unary__edvuaz = $this.bytesRead_1;
        $this.bytesRead_1 = add(_unary__edvuaz, get_ONE());
        return false;
      }
    }
    $this.matchIndex_1 = $this.matchIndex_1 + 1 | 0;
    if ($this.matchIndex_1 === $this.matchString_1.get_size_woubt6_k$()) {
      return true;
    }
    $this.partialMatchBuffer_1.writeByte_9ih3z3_k$(byte);
  }
  return false;
}
function checkBounds($this, extra) {
  if (add($this.bytesRead_1, extra) > $this.limit_1) {
    throw IOException().new_kotlinx_io_IOException_wvwdyo_k$('Limit of ' + $this.limit_1.toString() + ' bytes exceeded ' + ('while searching for "' + toSingleLineString($this, $this.matchString_1) + '"'));
  }
}
function toSingleLineString($this, $receiver) {
  return replace(decodeToString($receiver), '\n', '\\n');
}
var ByteChannelScannerClass;
function ByteChannelScanner() {
  if (ByteChannelScannerClass === VOID) {
    class $ {
      constructor(channel, matchString, writeChannel, limit) {
        limit = limit === VOID ? 9223372036854775807n : limit;
        this.channel_1 = channel;
        this.matchString_1 = matchString;
        this.writeChannel_1 = writeChannel;
        this.limit_1 = limit;
        // Inline function 'kotlin.require' call
        if (!(this.matchString_1.get_size_woubt6_k$() > 0)) {
          var message = 'Empty match string not permitted for scanning';
          throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message));
        }
        this.input_1 = this.channel_1.get_readBuffer_yjmj9b_k$();
        this.partialMatchTable_1 = buildPartialMatchTable(this);
        this.partialMatchBuffer_1 = new (Buffer())();
        this.bytesRead_1 = 0n;
        this.matchIndex_1 = 0;
      }
      *findNext_k7w4m8_k$(ignoreMissing, $completion) {
        this.bytesRead_1 = 0n;
        while (!this.input_1.exhausted_p1jt55_k$() || (yield* this.channel_1.awaitContent$default_rxihsg_k$(VOID, $completion))) {
          yield* /*#__NOINLINE__*/advanceToNextPotentialMatch(this, $completion);
          if (yield* /*#__NOINLINE__*/checkFullMatch(this, $completion)) {
            return this.bytesRead_1;
          }
        }
        if (!ignoreMissing) {
          throw IOException().new_kotlinx_io_IOException_wvwdyo_k$('Expected "' + toSingleLineString(this, this.matchString_1) + '" but encountered end of input');
        }
        this.bytesRead_1 = add(this.bytesRead_1, this.partialMatchBuffer_1.transferTo_lu4ka2_k$(this.writeChannel_1.get_writeBuffer_t7kuc6_k$()));
        yield* this.writeChannel_1.flush_4wsz1p_k$($completion);
        return this.bytesRead_1;
      }
    }
    initMetadataForClass($, 'ByteChannelScanner', VOID, VOID, VOID, [1, 0]);
    ByteChannelScannerClass = $;
  }
  return ByteChannelScannerClass;
}
//region block: exports
export {
  ByteChannelScanner as ByteChannelScanner1h148q1m3y1ey,
};
//endregion

//# sourceMappingURL=ByteChannelScanner.mjs.map
